<ion-header [translucent]="true">
	<ion-toolbar>
		<ion-title
			><span class="highlight">{{ 'creditCard.title' | translate }}</span
			><br
		/></ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="close()" fill="clear">
				<ion-icon name="close"></ion-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
	<div id="customCard-container"></div>
</ion-content>
<ion-footer class="ion-padding">
	<!-- Tip Display (read-only) -->
	@if (paySessionStatistics?.tipsValue) {
		<app-info-row>
			<div left>{{ 'common.tipLabel' | translate }}</div>
			<div right>{{ formattedTips }}</div>
		</app-info-row>
	}
	<hr class="divider" />
	<app-info-row>
		<div left>
			{{ 'statistics.total' | translate }} (<span>{{ paySessionStatistics?.selectedProductsCount }}</span> &nbsp;{{
				'statistics.items' | translate
			}})
		</div>
		<div right>{{ formattedTotalPrice }}</div>
	</app-info-row>
	@if (loading) {
		<ion-spinner></ion-spinner>
	} @else {
		<!-- Submit Button -->
		<ion-button (click)="confirmButton()" [disabled]="!isValid" class="pay-btn" expand="block">
			{{ 'common.payAmount' | translate: { amount: formattedTotalPrice } }}
		</ion-button>
	}
</ion-footer>
